const CarouselObjects = [
    {
        name: 'MainSlider',
        selector : $(".mainSlider__main-carousel"),
        type: 'owl',
        config: {
            loop: true,
	        merge:true,
            margin: 0,
            animateOut: 'fadeOut',
	        autoplayTimeout : 5000,
            mouseDrag : false,
	        autoplay: false,
            responsiveClass: true,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            dots: false,
            nav:true,
            responsive: {
                0: {
                    items: 1,
                    loop: true
                },
                1200: {
                    items: 1,
                    loop: true,
                    nav:false
                }
            }
        }
    },
    {
        name: 'RealisationsSlider',
        selector : $(".realisationsCarousel"),
        type: 'owl',
        config: {
            loop: false,
            margin: 0,
            animateOut: 'fadeOut',
            autoplay: false,
            responsiveClass: true,
            navText: ["<span class='arrow arrow--left'></span>", "<span class='arrow arrow--right'></span>"],
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1,
                    loop: true,
                    nav: true
                }
            }
        }
    },
    {
        name: 'PartnersSlider',
        selector : $(".JS_partnersSlider"),
        type: 'owl',
        config: {
            loop: true,
            margin: 0,
            animateOut: 'fadeOut',
            autoplay: false,
            responsiveClass: true,
            navText: ["<span class='arrow arrow--left'></span>", "<span class='arrow arrow--right'></span>"],
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1,
                    loop: true,
                    nav: false
                },
                481: {
                    items: 3,
                    loop: true,
                    nav: true
                },
                992: {
                    items: 4,
                    loop: true,
                    nav: true
                }
            }
        }
    }
];

export { CarouselObjects };


// WEBPACK FOOTER //
// ./js/predefinedObjects/CarouselObjects.js